import { isMockMode } from "@hopper-b2b/mock-utils";

/**
 * Starts the RBC mock worker when mock mode is active. Only the wallet-offers
 * endpoint is mocked (the BFF endpoint does not exist yet); all other requests
 * bypass to the real BFF.
 *
 * HOW TO ENABLE THE MOCK LOCALLY:
 *   1. Run the app: `yarn start:rbc`
 *   2. Open it with the `?mock=true` query param, e.g. http://localhost:3003/?mock=true
 *      (this persists for the session via localStorage — see `isMockMode`;
 *       clear it by opening with `?mock=false`).
 *   3. `GET /api/v0/wallet/offers` is then served from the fixture in
 *      `./fixtures/walletOffers.ts`.
 * The `rbc-wallet-offers` feature flag is NOT mocked — enable it for your
 * account in LaunchDarkly (and be signed in) to actually see the wallet UI.
 * (The `VITE_MOCK` env flag, set by the `preview -c mock` target, also works.)
 */
export const startMocks = async (): Promise<void> => {
  // `import.meta.env.MODE` is inlined by Vite at build time, so this early
  // return is statically true in production builds and the dynamic `./browser`
  // import (and all MSW mock infra) is tree-shaken out of the production bundle.
  if (import.meta.env.MODE === "production") {
    return;
  }

  const viteMock = import.meta.env.VITE_MOCK === "true";
  if (!isMockMode() && !viteMock) {
    return;
  }

  const { worker } = await import("./browser");
  await worker.start({ onUnhandledRequest: "bypass" });
};
